module.exports = __webpack_public_path__ + "static/media/style transfer.aab48692.gif";